import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Drafts: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.91249 14.9375H13.0875C13.5983 14.9375 14.0125 14.5233 14.0125 14.0125V5.60795C14.0124 5.36279 13.9151 5.12769 13.7418 4.95428L10.1207 1.33322C9.9473 1.15992 9.71216 1.06255 9.46704 1.0625H2.91249C2.40867 1.0625 1.98749 1.48368 1.98749 1.9875V14.0125C1.98749 14.5163 2.40867 14.9375 2.91249 14.9375Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0125 5.6875H10.3125C10.0672 5.6875 9.83188 5.59004 9.65841 5.41657C9.48495 5.24311 9.38751 5.00782 9.38751 4.7625V1.0625"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
